import { createSlice } from "@reduxjs/toolkit";

/**
 * Redux slice for managing chat messages.
 * @module chatSlice
 */
const chatSlice = createSlice({
  name: "chat",
  initialState: {
    messages: [],
    showChat: window.innerWidth <= 767 ? true : false,
  },
  reducers: {
/**
 * Appends new chat messages to the existing messages in the state.
 *
 * @param {Object} state - The current state of the chat slice.
 * @param {Object} action - The action object containing the payload.
 * @param {Array} action.payload - An array of new chat messages to be added.
 */
    setChatMessages: (state,action) => {
      state.messages = [...state.messages, ...action.payload];

    },
    setShowChat: (state, action) => {
      state.showChat = action.payload;
    }
  },
});
export const { setChatMessages, setShowChat } = chatSlice.actions;
export default chatSlice.reducer;
